function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M9.127 6.53103L5.56677 8.10392C4.84234 8.42397 4.375 9.14135 4.375 9.93333V11.5245C4.375 12.56 5.21447 13.3995 6.25 13.3995C7.28553 13.3995 8.125 14.2389 8.125 15.2745V20.9375C8.125 22.0421 9.02043 22.9375 10.125 22.9375H18.6875C19.7921 22.9375 20.6875 22.0421 20.6875 20.9375V15.3682C20.6875 14.2809 21.5689 13.3995 22.6562 13.3995C23.7436 13.3995 24.625 12.518 24.625 11.4307V9.99549C24.625 9.1722 24.1205 8.43302 23.3538 8.13301L19.1229 6.47746C18.4655 6.22021 17.7279 6.34149 17.1397 6.73177C14.9968 8.15342 13.4194 8.16153 11.1437 6.72045C10.5379 6.33684 9.78288 6.24126 9.127 6.53103Z",
  stroke: "white",
  strokeWidth: 2
});

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 14.5,
  cy: 14.5,
  r: 13.5,
  stroke: "white",
  strokeWidth: 2
});

function SvgKids(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKids);
export default __webpack_public_path__ + "static/media/kids.b5ce9a6a.svg";
export { ForwardRef as ReactComponent };